<script setup>
import { ref } from 'vue'
import TableList from '../others/TableList.vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Commons from '@/shared/utils/commons'
import { EVENTS } from '@/shared/constants/commons'
import Events from '@/events/events'

const statusTrigger = ref(null)

const cols = [
  {
    name: 'Utilisateur',
    id: 'user',
    value(el) {
      const user = el.user || {}
      return [user.name || 'Utilisateur', user.email || '-']
    },
  },
  {
    name: 'Montant',
    id: 'amount',
    value(el) {
      return Commons.formatNumber(el.amount, { suffix: ` ${el.currency || 'XOF'}` })
    },
  },
  {
    name: 'Méthode',
    id: 'method',
    value(el) {
       return el.method || el.type || '-'
    }
  },
  {
    name: 'Statut',
    id: 'status',
    value(el) {
      const status = (el.status || 'pending').toLowerCase()
      const colors = {
        pending: 'text-warning-600 bg-warning-50 px-2 py-1 rounded-full text-xs font-medium',
        approved: 'text-primary-600 bg-primary-50 px-2 py-1 rounded-full text-xs font-medium',
        completed: 'text-success-600 bg-success-50 px-2 py-1 rounded-full text-xs font-medium',
        rejected: 'text-error-600 bg-error-50 px-2 py-1 rounded-full text-xs font-medium'
      }
      const colorClass = colors[status] || 'text-gray-600 bg-gray-50 px-2 py-1 rounded-full text-xs font-medium'
      return `<span class="${colorClass}">${status}</span>`
    }
  },
  {
    name: 'Date',
    id: 'createdAt',
    value(el) {
      return Commons.time(el.createdAt)
    }
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/dots.png',
    options(el) {
       if (el.status?.toLowerCase() !== 'pending') return []
       return [
         { name: 'Approuver', value: 'approved' },
         { name: 'Rejeter', value: 'rejected' }
       ]
    },
    onClick(opt, el) {
       const action = (typeof opt === 'object' ? opt.value : opt)?.toLowerCase()
       if (!action) return
       
       const confirmMsg = action === 'approved' 
         ? 'Voulez-vous approuver cette demande de retrait ?' 
         : 'Voulez-vous rejeter cette demande de retrait ?'
         
       if (confirm(confirmMsg)) {
         statusTrigger.value.trigger({ id: el.id, status: action })
       }
    },
    value() {}
  }
]

const onStatusSuccess = () => {
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'Succès',
    body: 'Le statut du retrait a été mis à jour',
    type: 'success'
  })
}

const onStatusError = (err) => {
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    title: 'Erreur',
    body: err?.message || 'Impossible de mettre à jour le retrait',
    type: 'error'
  })
}
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <TableList
      title="Gestion des Retraits"
      dataKey="adminWithdrawals"
      hasSearch
      :cols="cols"
      refreshOnEvents="WITHDRAWAL_UPDATED"
    ></TableList>

    <ActionTrigger
      dataKey="updateWithdrawalStatus"
      ref="statusTrigger"
      @success="onStatusSuccess"
      @failed="onStatusError"
      dispatchOnSuccess="WITHDRAWAL_UPDATED"
    />
  </div>
</template>
